<template>
  <div id="footer">
    <v-footer class="footer" padless>
      <v-container>
        <v-row>
          <v-col class="text-left">
            <div>
              <v-container>
                <v-row justify="center">
                  <v-col cols="12" sm="3" md="3" lg="2">
                    <div class="about">
                      <img src="@/assets/images/logo-white-tcs.webp" class="footer__logo" />
                    </div>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" lg="2">
                    <div>
                      <h3 class="footer__title">Nosotros</h3>
                      <p class="footer__text">
                        <a
                          class="footer__link"
                          href="mailto:hola@trabajoconsentido.com"
                        >
                          Necesitas contactarnos
                        </a>
                      </p>
                      <p class="footer__text">
                        <a
                          class="footer__link"
                          :href="getPrivacyProtection"
                          target="_blank"
                        >
                          Política de privacidad, datos personales y condiciones de uso
                        </a>
                      </p>
                      <p class="footer__text">
                        <a
                          class="footer__link"
                          :href="getModeration"
                          target="_blank"
                        >
                          tica de moderación
                        </a>
                      </p>
                      <p class="footer__text">
                        <a
                          class="footer__link"
                          href="https://trabajosconsentido.freshdesk.com/support/solutions"
                          target="_blank"
                        >
                          Centro de ayuda
                        </a>
                      </p>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="3" md="3" lg="2">
                    <div>
                      <h3 class="footer__title">Web</h3>
                      <p class="footer__text ma-0">
                        <router-link class="footer__link" to="/register">
                          Regístrate
                        </router-link>
                      </p>
                      <p class="footer__text ma-0">
                        <router-link class="footer__link" to="/login">
                          Iniciar sesión
                        </router-link>
                      </p>
                      <p class="footer__text ma-0">
                        <router-link class="footer__link" to="/offers">
                          Ofertas de trabajo
                        </router-link>
                      </p>
                      <p v-if="!isCandidate" class="footer__text ma-0">
                        <router-link class="footer__link" to="/soy-organizacion">
                          Soy organización
                        </router-link>
                      </p>
                      <p v-if="!isCandidate" class="footer__text ma-0">
                        <router-link class="footer__link" to="/register/organization">
                          Publica tu oferta
                        </router-link>
                      </p>
                      <p v-if="!isCandidate" class="footer__text ma-0">
                        <router-link class="footer__link" to="/pricing">
                          Planes y Precios
                        </router-link>
                      </p>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="8" md="8" lg="6" class="d-none d-sm-block">
                    <div class="text-center text-sm-left text-md-left">
                      <h3 class="footer__title">Somos parte de:</h3>
                      <v-row justify="center" justify-md="start">
                        <v-col cols="2" sm="2" md="2" lg="2" class="pa-0">
                          <img src="@/assets/images/logo-empresa-b.webp" class="footer__icon" />
                        </v-col>
                        <v-col cols="3" sm="3" md="3" lg="3" class="pa-0">
                          <img src="@/assets/images/logo-corfo.webp" class="footer__icon" />
                        </v-col>
                        <v-col cols="3" sm="3" md="3" lg="3" class="pa-0">
                          <img src="@/assets/images/logo-prochile.webp" class="footer__icon" />
                        </v-col>
                        <v-col cols="3" sm="3" md="3" lg="3" class="pa-0">
                          <img
                            src="@/assets/images/logo-chileglobal-ventures.webp"
                            class="footer__icon"
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col align-self="center" class="text-center text-md-right pa-0">
                          <img
                            src="@/assets/images/logo-chilecompra.webp"
                            class="footer__icon-compra"
                          />
                        </v-col>
                      </v-row>
                    </div>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
    <v-footer class="post-footer" padless>
      <v-container>
        <v-row>
          <v-col cols="12" md="6" class="pa-0">
            <div class="text-center text-sm-center text-md-left">
              <p class="post-footer__text">Únete a la conversación en:</p>
              <ul class="ma-0 pa-0">
                <li class="post-footer__social">
                  <v-btn
                    href="https://www.linkedin.com/company/trabajoconsentido/"
                    target="_blank"
                    icon
                    large
                    color="white"
                    class="btn-social"
                  >
                    <v-icon>mdi-linkedin</v-icon>
                  </v-btn>
                </li>
                <li class="post-footer__social">
                  <v-btn
                    href="https://www.instagram.com/trabajoconsentido_/"
                    target="_blank"
                    icon
                    large
                    color="white"
                    class="btn-social"
                  >
                    <v-icon>mdi-instagram</v-icon>
                  </v-btn>
                </li>
                <li class="post-footer__social">
                  <v-btn
                    href="https://www.facebook.com/trabajoconsentido/"
                    target="_blank"
                    icon
                    large
                    color="white"
                    class="btn-social"
                  >
                    <v-icon>mdi-facebook</v-icon>
                  </v-btn>
                </li>
                <li class="post-footer__social">
                  <v-btn
                    href="https://www.youtube.com/channel/UCs6TRyy2vDjZtfiq8ieDajw"
                    target="_blank"
                    icon
                    large
                    color="white"
                    class="btn-social"
                  >
                    <v-icon>mdi-youtube</v-icon>
                  </v-btn>
                </li>
                <li class="post-footer__social">
                  <v-btn
                    href="https://twitter.com/trabajocsentido/"
                    target="_blank"
                    icon
                    large
                    color="white"
                    class="btn-social"
                  >
                    <v-icon>mdi-twitter</v-icon>
                  </v-btn>
                </li>
              </ul>
            </div>
          </v-col>
          <v-col cols="12" md="6" class="pa-0">
            <div class="text-center text-sm-center text-md-right">
              <div class="py-7">
                <p class="post-footer__copyright">&copy;2020, Pegas con sentido</p>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { currentFile } from "@/libs/mixins";

export default {
    name: "Footer",

    mixins: [currentFile],

    computed: {
        ...mapGetters("users", ["getType"]),

        isCandidate() {
            return this.getType === "candidate";
        },
    },
};
</script>
